export const coordenador_caps = {
  nome: 'Coordenador(a) do CAPS',
  id_perfil: 16,
  dashboard: [
    {
      link: '/caps',
      titulo: 'CAPS',
      icone: false,
      imagem: '',
      svg: 'Caps',
      key: 'caps',
      featured: true,
    },
  ],
  administracao: [],
  gestao_cadastros: [],
  visitas_domiciliares: [],
  imunizacao: [],
  vacina_idade_certa: [],
  divergencia_vacinas: [],
  indicadores_aps: [],
  pre_natal: [],
  doencas_cronicas: [],
  desempenho_por_equipe: [],
  saude_crianca: [],
  producao: [],
  vinculo_acompanhamento: [],
  bpa_e_ras: [],
  saude_bucal: [],
  indicadores_esb: [],
  esf_eap: [],
  emulti: [],
  oficinas_treinamentos: [],
  upa: [],
  administracao_importar_dados: [],
  caps: [
    {
      link: '/caps/ma-no-caps',
      titulo: 'M & A no CAPS',
      icone: 'icofont-copy-invert',
      key: 'ma_no_caps',
    },
    // {
    //   link: '/bpa-e-raas/importar-raas',
    //   titulo: 'Importar RAAS',
    //   icone: false,
    //   imagem: '',
    //   svg: 'ImportarRaas',
    //   key: 'importar_raas',
    // },
    // {
    //   link: '/bpa-e-raas/exportar-raas',
    //   titulo: 'Exportar RAAS',
    //   icone: false,
    //   imagem: '',
    //   svg: 'ExportarRaas',
    //   key: 'exportar_raas',
    // },
  ],
}
